import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { GraphSnapshot } from 'dashboard/models/graph-snapshot';
import { setGraphSnapshot } from 'dashboard/redux/actions/graph-snapshots';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

import { DashboardThunkAction } from '../types';

export function createGraphSnapshot(
  graphId: string | undefined,
  graphQueryId: string,
  payload: GraphSnapshot['attributes'],
) {
  return async (dispatch: Dispatch) => {
    const { data: graphSnapshot } = await SessionClientDashboard.postResourceCreate<GraphSnapshot>({
      type: ApiModel.GraphSnapshot,
      attributes: payload,
      relationships: {
        graph: {
          data: {
            type: ApiModel.Graph,
            id: graphId,
          },
        },
        'graph-query': {
          data: {
            type: ApiModel.GraphQuery,
            id: graphQueryId,
          },
        },
      },
    });
    dispatch(setGraphSnapshot(graphSnapshot));
    return graphSnapshot;
  };
}

export function fetchGraphSnapshot(snapshotId: string): DashboardThunkAction {
  return async (dispatch: Dispatch) => {
    const { data: graphSnapshot } = await SessionClientDashboard.getResource<GraphSnapshot>(
      ApiEndpoint.GraphSnapshot,
      snapshotId,
    );
    dispatch(setGraphSnapshot(graphSnapshot));
  };
}
